import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

// ── Mantener Railway despierto ──
setInterval(() => {
  fetch(`${process.env.REACT_APP_API_URL}/ping`).catch(() => {});
}, 14 * 60 * 1000);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();